import { GameEntity, SchemaField } from '@okletsplay/core';
import { useMemo } from 'react';

export const useDefaultTournamentSettingsForm = (game: GameEntity | undefined) => {
  const teamsSettingsSchema = useMemo(() => game?.tournamentsConfiguration?.teamsSettings, [game]);
  const matchSetupSettingsSchema = useMemo(
    () => game?.tournamentsConfiguration?.matchSetupSettings,
    [game]
  );
  const teamsSettingsDefaultValues = useMemo(() => {
    if (!teamsSettingsSchema?.properties) {
      return {};
    }

    return {
      teamSize: teamsSettingsSchema?.properties?.teamSize?.defaultValue as number,
      minTeams: teamsSettingsSchema?.properties?.minTeams?.defaultValue as number,
      maxTeams: teamsSettingsSchema?.properties?.maxTeams?.defaultValue as number,
      ...Object.entries(teamsSettingsSchema?.properties).reduce((res, [field, config]) => {
        res[field] = (config as SchemaField).defaultValue;
        return res;
      }, {} as Record<string, string | number>),
    };
  }, [teamsSettingsSchema?.properties]);

  // OKLP-594: this one; extract to separate hook
  const matchSetupSettingsDefaultValues = useMemo(() => {
    if (!matchSetupSettingsSchema?.properties) {
      return {};
    }

    return {
      eliminationFormat: matchSetupSettingsSchema?.properties?.eliminationFormat
        ?.defaultValue as string,
      ...Object.entries(matchSetupSettingsSchema?.properties).reduce((res, [field, config]) => {
        res[field] = (config as SchemaField).defaultValue;
        return res;
      }, {} as Record<string, string | number>),
    };
  }, [matchSetupSettingsSchema?.properties]);

  return {
    teamsSettingsSchema,
    matchSetupSettingsSchema,
    teamsSettingsDefaultValues,
    matchSetupSettingsDefaultValues,
  };
};
